/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2017 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/

import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { LandingPageComponent } from "./landing-page/landing-page/landing-page.component";
import { LoginComponent } from "./register-login/layout/login/login.component";

import { ServerErrorComponent } from "./shared/components/server-error/server-error.component";
import { AuthGuard } from "./register-login/guard/auth.guard";
import { ServererrorComponent } from "./server-error/servererror.component";
import { LogoutComponent } from "./register-login/layout/logout/logout.component";

const routes: Routes = [
  { path: "", component: LoginComponent },
  // {
  //   path: "home",
  //   canActivate: [AuthGuard],
  //   loadChildren: () =>
  //     import("./landing-page/landing-page.module").then((m) => m.LandingpageModule),
  // },
  { path: "home", component: LandingPageComponent, canActivate: [AuthGuard] },
  { path: "login", component: LoginComponent },
  { path: "logout", component: LogoutComponent },
  { path: "error", component: ServerErrorComponent }
 
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
